module.exports = __webpack_public_path__ + "static/bigcommerce_4-2a3592f38f8384283f586a279a4a244a.png";